
import React from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import OrganizerDashboard from "../pages/OrganizerDashboard";
import OrganizerProfile from "../pages/OrganizerProfile";
import ChangePassword from "../pages/ChangePassword";
import { UserRoles } from "@/contexts/auth/enums";
import OrganizerLayout from "@/pages/organizer/OrganizerLayout";
import { sendPageView } from "@/services/analyticsService";

const OrganizerRoutes = (): RouteObject[] => [
  {
    path: "/organizer/dashboard",
    element: (
      <ProtectedRoute 
        requireAuth={true}
        requiredRole={UserRoles.ORGANIZER}
        onEnter={() => sendPageView("Szervezői vezérlőpult")}
      >
        <OrganizerLayout>
          <OrganizerDashboard />
        </OrganizerLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/organizer/profile",
    element: (
      <ProtectedRoute 
        requireAuth={true}
        requiredRole={UserRoles.ORGANIZER}
        onEnter={() => sendPageView("Szervezői profil")}
      >
        <OrganizerLayout>
          <OrganizerProfile />
        </OrganizerLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/organizer/change-password",
    element: (
      <ProtectedRoute 
        requireAuth={true}
        requiredRole={UserRoles.ORGANIZER}
        onEnter={() => sendPageView("Jelszó módosítás - Szervező")}
      >
        <OrganizerLayout>
          <ChangePassword />
        </OrganizerLayout>
      </ProtectedRoute>
    )
  }
];

export default OrganizerRoutes;
